import $ from 'jquery'
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import scrollToHandler from '../scrollToHandler'

document.addEventListener('DOMContentLoaded', () => {
  const navbar = document.getElementById('navbar')
  document.querySelectorAll('.nav-link, .scroll-link, .buttons a')
      .forEach(e => e.addEventListener('click', scrollToHandler(e, $(navbar))))

  const $galleryModal = $('#galleryModal')
  const galleryModalImg = document.getElementById('galleryModalImg')
  document.querySelectorAll('section.gallery .image').forEach(i => {
    i.addEventListener('click', e => {
      e.preventDefault()
      galleryModalImg.src = e.target.src
      $galleryModal.modal('show')
    })
  })

  const contact = document.getElementById('contacto').querySelector('form')

  contact.addEventListener('submit', e => {
    const email = contact.querySelector('[name=email]').value
    const message = contact.querySelector('[name=message]').value
    const privacyPolicy = contact.querySelector('[type=checkbox][name=privacy_policy]').checked
    if (email === '' || message === '' || !privacyPolicy) {
      e.stopPropagation();
      e.preventDefault()
      contact.querySelector('.validation').classList.toggle('d-none', false)
      contact.querySelector('.success').classList.toggle('d-none', true)
      contact.querySelector('.error').classList.toggle('d-none', true)
    }
  })
  contact.addEventListener('ajax:success', e => {
    contact.querySelector('.validation').classList.toggle('d-none', true)
    contact.querySelector('.success').classList.toggle('d-none', false)
    contact.querySelector('.error').classList.toggle('d-none', true)
  })
  contact.addEventListener('ajax:error', e => {
    contact.querySelector('.validation').classList.toggle('d-none', true)
    contact.querySelector('.success').classList.toggle('d-none', true)
    contact.querySelector('.error').classList.toggle('d-none', false)
  })
})

